import { DynamicPage } from 'src/components';
import formObj from './formObj';

export const ExamInfo = () => {
  return <DynamicPage formObj={formObj} />;
};
